import store from '@/store'

const routes = [{
    path: '/sales/stocks-inquiry/:id',
    name: 'stocksinquiry',
    props: true,
    component: () => import('@/views/main/modules/Sales/StocksInquiry/StocksInquiryGroupComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Stocks Inquiry',
    },
}];

export default routes;
